import { Group, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';
import { InfoNote } from './info-note';
import classes from './section-heading.module.css';

interface SectionHeadingProps {
  title: string;
  /** One line at most. Anything longer belongs in `note`. */
  subtitle?: string;
  /** Small label above the title — what kind of thing this section is. */
  eyebrow?: string;
  /** The argument for why this is measured this way. Goes behind an info icon. */
  note?: string;
  /** Badges or controls, right-aligned. */
  actions?: ReactNode;
}

/** The heading block for a section within a screen. */
export function SectionHeading({
  title,
  subtitle,
  eyebrow,
  note,
  actions,
}: SectionHeadingProps) {
  return (
    <Group justify="space-between" align="flex-start" wrap="wrap" gap="sm">
      <Stack gap={2}>
        {eyebrow && (
          <Text size="xs" fw={600} c="dimmed" className={classes.eyebrow}>
            {eyebrow}
          </Text>
        )}
        <Group gap={4} wrap="nowrap" align="center">
          <Title order={4}>{title}</Title>
          {note && <InfoNote label={`Why ${title.toLowerCase()} is measured this way`}>{note}</InfoNote>}
        </Group>
        {subtitle && (
          <Text size="sm" c="dimmed">
            {subtitle}
          </Text>
        )}
      </Stack>
      {actions}
    </Group>
  );
}
